import React from "react";

const ViewInvoiceModal = ({ invoice, closeModal }) => {
  if (!invoice) return null;

  const isPdf = invoice.invoiceFile?.toLowerCase().endsWith(".pdf");

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-3xl max-h-[90vh] flex flex-col relative">
        {/* Header with sticky close button */}
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="text-xl font-bold text-gray-800">
            Invoice #{invoice.invoiceNumber}
          </h2>
          <button
            onClick={closeModal}
            className="text-gray-600 hover:text-gray-900 text-lg"
          >
            ✕
          </button>
        </div>

        {/* Scrollable content */}
        <div className="p-6 overflow-y-auto">
          {/* Metadata */}
          <div className="grid grid-cols-2 gap-4 mb-6 text-sm">
            <div>
              <p className="text-gray-500">Purchase Order</p>
              <p className="font-medium">{invoice.po?.poNumber || "N/A"}</p>
            </div>
            <div>
              <p className="text-gray-500">Vendor</p>
              <p className="font-medium">{invoice.po?.vendorName || "N/A"}</p>
            </div>
            <div>
              <p className="text-gray-500">Amount</p>
              <p className="font-medium">
                {invoice.amount ? `$${invoice.amount.toFixed(2)}` : "N/A"}
              </p>
            </div>
            <div>
              <p className="text-gray-500">Status</p>
              <p className="font-medium">{invoice.status || "N/A"}</p>
            </div>
            <div>
              <p className="text-gray-500">Invoice Date</p>
              <p className="font-medium">
                {invoice.invoiceDate
                  ? new Date(invoice.invoiceDate).toLocaleDateString()
                  : "-"}
              </p>
            </div>
            <div>
              <p className="text-gray-500">Due Date</p>
              <p className="font-medium">
                {invoice.dueDate
                  ? new Date(invoice.dueDate).toLocaleDateString()
                  : "-"}
              </p>
            </div>
            <div>
              <p className="text-gray-500">Created By</p>
              <p className="font-medium">
                {invoice.createdBy?.name || invoice.createdBy?.email || "N/A"}
              </p>
            </div>
          </div>

          {/* File preview */}
          {invoice.invoiceFile && (
            <div className="border rounded-lg overflow-hidden">
              {isPdf ? (
                <iframe
                  src={invoice.invoiceFile}
                  title="Invoice PDF"
                  className="w-full h-[400px]"
                />
              ) : (
                <img
                  src={invoice.invoiceFile}
                  alt="Invoice"
                  className="w-full h-[400px] object-contain bg-gray-100"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewInvoiceModal;
